import { defineMessages } from "react-intl";

import {
	causeOfGraftlossMessages,
	hasGraftlossMessages,
	validator
} from "lib/build/forms/ktx/basic-registration-data/waiting-list-data/graftloss";

import { FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	graftloss: {
		id: "ktx.form.graftloss.title",
		defaultMessage: "Graftvesztés"
	},
	hasGraftloss: {
		id: "ktx.form.graftloss.hasGraftloss",
		defaultMessage: "Graftvesztés?"
	},
	causeOfGraftloss: {
		id: "ktx.form.graftloss.value",
		defaultMessage: "Graftvesztés oka"
	},
	other: {
		id: "ktx.form.graftloss.other",
		defaultMessage: "Egyéb"
	}
});

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["hasGraftloss"],
						label: messages.hasGraftloss,
						errorMessages: genericErrorMessages,
						input: {
							type: "button-group",
							props: {
								labels: hasGraftlossMessages
							}
						}
					}
				}
			]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["graftloss", "causeOfGraftloss"],
						label: messages.causeOfGraftloss,
						errorMessages: genericErrorMessages,
						input: {
							type: "select",
							props: {
								labels: causeOfGraftlossMessages
							}
						}
					}
				}
			]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["graftloss", "causeOfGraftlossOther"],
						label: messages.other,
						errorMessages: genericErrorMessages,
						input: {
							type: "textarea",
							props: {}
						}
					}
				}
			]
		}
	]
};

export const node: LeafNode = {
	id: "ktx_graftloss",
	value: {
		schemaId: "graftloss",
		title: messages.graftloss,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
